import { models } from '@kurtosys/ksys-app-template';
import { IAppConfigurationBase } from '../models/app/IAppConfigurationBase';

export const APPLICATION_CLIENT_CONFIGURATIONS: models.api.applicationManager.IApplicationClientConfiguration[] = [
	{
		applicationClientConfigurationId: 1,
		configuration: {
			culture: {
				base: 'Default',
				default: 'en-GB',
			},
			core: {
				inputs: {
					queries: [
						{
							queryId: 'urlPattern',
							queryOptionsType: 'none',
							value: '/:fundId',
						},
						{
							queryId: 'urlFundId',
							queryOptionsType: 'url',
							code: 'param',
							urlPattern: {
								queryOptionsType: 'input',
								key: 'urlPattern',
							},
							key: 'fundId',
						},
					],
				},
				skeletonLoaders: {
					variables: [
						{
							key: 'fillColor',
							value: '#dddddd',
						},
					],
					loaders: [
						{
							id: 'ksys-app-start',
							breakpoints: [
								{
									minWidthInPixels: 0,
									style: {
										height: '86px',
									},
									children: [
										{
											'fill': '{fillColor}',
											'x': '0px',
											'y': '11.90625px',
											'height': '28px',
											'width': '100%',
										},
										{
											'fill': '{fillColor}',
											'x': '0px',
											'y': '59.8125px',
											'height': '18px',
											'width': '100%',
										},
									],
								},
							],
						},
					],
				},
			},
			data: {
				context: {
					entities: [
						{
							id: 'classes',
							inputs: [
								{
									key: 'audience',
									query: {
										queryOptionsType: 'input',
										key: 'audience'
									}
								},
								{
									key: 'country',
									query: {
										queryOptionsType: 'input',
										key: 'country'
									}
								}
							],
							requestBodyQueries: {
								type: 'CLSS',
								search: [
									{
										property: {
											queryOptionsType: 'none',
											value: 'isin'
										},
										matchtype: 'MATCH',
										values: {
											queryOptionsType: 'input',
											options: {
												input: {
													key: 'isins'
												}
											},
											transforms: [
												{
													transformOptionsType: 'split',
													splitSeparator: ','
												}
											]
										},
									}
								],
								include: {
									documents: {
										joinSpec: [
											{
												joinTo: 'isin',
												joinFrom: 'isin',
												search: [
													{
														property: 'audience',
														matchtype: 'MATCH',
														values: ['{input:audience}'],
													},
													{
														property: 'publication_country',
														matchtype: 'MATCH',
														values: ['{input:country}'],
													},
												],
											},
											{
												joinTo: 'fund_code',
												joinFrom: 'fund_code',
												search: [
													{
														property: 'audience',
														matchtype: 'MATCH',
														values: ['{input:audience}'],
													},
													{
														property: 'publication_country',
														matchtype: 'MATCH',
														values: ['{input:country}'],
													},
												],
											},
											{
												joinTo: 'umbrella_code',
												joinFrom: 'fund_umbrella_code',
												search: [
													{
														property: 'audience',
														matchtype: 'MATCH',
														values: ['{input:audience}'],
													},
													{
														property: 'publication_country',
														matchtype: 'MATCH',
														values: ['{input:country}'],
													},
												],
											},
										],
									},
								},
							},
						}
					],
					globalDocuments: [
						// {
						// 	type: '',
						// 	search: [
						// 		{
						// 			matchtype: 'MATCH',
						// 			property: 'audience',
						// 			meta: true,
						// 			values: [
						// 				'{input:audience}',
						// 			],
						// 		},
						// 	],
						// },
					],
					globalDisclaimers: [
						{
							global: true,
						},
					],
				},
			},
			accessibilityConfig: {
				asset: {
					base: {
						accordionPanel: {
							collapseIcon: {
								value: 'Button to close the panel',
							},
							expandIcon: {
								value: 'Button to open the panel',
							},
						},
					},
				},
				tables: {
					performance: {
						caption: {
							value: 'Past Performance',
						},
					},
				},
			},
		} as IAppConfigurationBase,
		name: 'root',
		applicationClientConfigurationTypeId: 1,
	},
];
